<template>
  <div class="p-2">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'Print',
  mounted () {
    this.setBackgrounds()
  },
  destroyed () {
    this.unsetBackgrounds()
  },
  methods: {
    setBackgrounds () {
      document.querySelectorAll('body')
      .forEach(o => {
        o.style.cssText = 'background: #fff !important'
      })
    },
    unsetBackgrounds () {
      document.querySelectorAll('body')
      .forEach(o => {
        o.removeAttribute('style')
      })
    }
  }
}
</script>
